import { get, pick, assign } from 'lodash';
import { updatePrice, fetchListingPricing } from '../../../app-main/actions/listingPricing';
import { updateListing } from '../../../app-main/actions/listing';
import { toggleBanner } from '../../../app-main/actions/banner';

const onChangePriceForm = (values, dispatch, props) => {
  const priceId = get(values, 'prices._id', '');
  const accessToken = get(props, 'accessToken', '');
  const listingId = get(props, 'listing._id', '');
  const { prices = {}, fandb = {} } = values;

  if (fandb.fandb_required) {
    // For FNB pricing, we need to get the pricing payload by going through the pricing calc first
    const value = prices.base_value; // need to convert base_value to value
    const payload = assign({}, { value }, pick(prices, ['currency', 'tax_percent', 'display_gratuity_percent']));
    const calcQueryString = Object.keys(payload).map(key => `${key}=${payload[key]}`).join('&');

    return dispatch(fetchListingPricing(`calc?${calcQueryString}`))
      .then((fnbPayload) => {
        dispatch(updatePrice(priceId, accessToken, fnbPayload));
      })
      .then(() => dispatch(updateListing(listingId, accessToken, fandb)))
      .then(() => dispatch(toggleBanner('save')))
      .catch(() => dispatch(toggleBanner('error')));
  }

  const payload = pick(prices, ['value', 'currency']);
  return dispatch(updatePrice(priceId, accessToken, payload))
    .then(() => dispatch(toggleBanner('save')))
    .catch(() => dispatch(toggleBanner('error')));
};

export default onChangePriceForm;
